import { Button } from "components/Button/Button";
import NotFound from "components/not-found/NotFound";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { toast } from "react-hot-toast";
import Pagination from "react-js-pagination";
import { dataIsAvailable, dateFormat } from "utils";
import { Input, Select, TextArea } from "components/Form";
import ReactSelect from "react-select";
import {
    addFreeCourseAccess,
    addPersonalizedLectureAccessByCourse,
    // addPersonalizedLectureAccessByCourse,
    getCoursesViaStudentEmail,
    getLectureViaStudentEmail,
    getLectureViaStudentEmailbyCourse,
} from "services/student/studentController";
import CourseModal from "./Sections/CourseModal";
import ModalBox from "components/modal/ModalBox";
import {
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import CommentBankIcon from "@mui/icons-material/CommentBank";
import Paper from "@mui/material/Paper";
import CommentRow from "./CommentRow";
import { useSearchParams } from "react-router-dom";
import BulkCourseModal from "./Sections/BulkCourseModal";
import { getMasterSubjects, getMasterSubSubjects } from "services/master";
import { Checkbox } from "@mui/material";
import { getactivecourseskyc } from "services/KYC/KYCcontroller";

const PersonalizedLectureAccessByCourse = () => {
    const [searchParam, setSearchParam] = useSearchParams();
    let activePage = +searchParam.get("page") || 1;
    let search = searchParam.get("query") || "";
    const [page, setPage] = useState(activePage);


    const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
    const [submitButtonElement2, setSubmitLoading2] = useMuiButtonLoader();
    const [userEmail, setUserEmail] = useState(search || "");
    const [lecturesearch, setlecturesearch] = useState("");
    const [selectedCourseId, setSelectedCourseId] = useState("");
    const [userData, setUserData] = useState({});
    const [allCourses, setAllCourses] = useState([]);

    const [confirmModal, setConfirmModal] = useState(false);
    const [revokeModal, setRevokeModal] = useState(false);
    const [commentModal, setCommentModal] = useState(false);
    const [comment, setComment] = useState("");
    const [commentError, setCommentError] = useState("");
    const [allComments, setAllComments] = useState([]);
    const [allSubjects, setAllSubjects] = useState([]);
    const [allSubSubjects, setAllSubSubjects] = useState([]);
    const [selectedSubject, setSelectedSubject] = useState("");
    const [selectedSubSubject, setSelectedSubSubject] = useState(null);
    const [selectedId, setSelectedId] = useState([]);
    const [allLectureids, setAllLectureids] = useState([]);
    const [selectedLectures, setSelectedLectures] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState(null);


    const [record, setRecord] = useState([]);
    const [total, setTotal] = useState(0);

    const [loader, showLoader, hideLoader] = useFullPageLoader();

    const fetchLectures = async (pageNumber) => {
        showLoader();

        const finalData = {
            accessType: "normal",
            search: userEmail,
            page: pageNumber,
            subjectid: selectedSubject?.value || "",
            subsubjectid: selectedSubSubject?.value || "",
            lectureSearch: lecturesearch,
            courseid: selectedCourse?.value,
        };

        try {
            const res = await getLectureViaStudentEmailbyCourse(finalData);
            hideLoader();

            if (res.code === 200) {
                setRecord(res.data.lectures?.rows || []);
                setTotal(res.data.lectures?.count || 0);
                setUserData(res.data.studentdetails || {});
            } else {
                setRecord([]);
                setTotal(0);
                toast.error(res.message);
            }
        } catch (err) {
            hideLoader();
            toast.error(err.message);
        }
    };

    const searchHandler = async (e) => {
        e.preventDefault();

        if (!userEmail || !selectedCourse) {
            toast.error("Please enter email/phone and select course");
            return;
        }

        // 👇 DO NOT RESET PAGE HERE
        searchParam.set("query", userEmail);
        searchParam.set("page", page);
        setSearchParam(searchParam);

        fetchLectures(page);
    };


    const isNewSearch = () => {
        return (
            page !== activePage ||
            lecturesearch ||
            selectedSubject ||
            selectedSubSubject
        );
    };



    const handlePageChange = (newPage) => {
        setPage(newPage);
        searchParam.set("page", newPage);
        setSearchParam(searchParam);

        fetchLectures(newPage);
    };

    useEffect(() => {
        if (!userEmail || !selectedCourse) return;

        setPage(1);
        searchParam.set("page", 1);
        setSearchParam(searchParam);

        fetchLectures(1);
    }, [lecturesearch, selectedSubject, selectedSubSubject, selectedCourse]);




    useEffect(() => {
        setSearchParam({});
        setUserEmail("");
        setRecord([]);
        setTotal(0);
        setUserData({});
        setSelectedCourse(null)
    }, []);

    const resetFilter = async () => {
        // Clear lecture search and dropdowns
        setlecturesearch("");
        setSelectedSubject("");
        setSelectedSubSubject(null);

        // Reset page and query param
        setSearchParam({});

        // Fetch the lectures again for the student without filters
        if (userEmail) {
            try {
                showLoader();
                const finalData = {
                    accessType: "normal",
                    search: userEmail,
                    page: 1, // reset page
                    subjectid: "",
                    subsubjectid: "",
                    courseid: selectedCourse?.value
                };
                const res = await getLectureViaStudentEmailbyCourse(finalData);
                hideLoader();

                if (res.code === 200) {
                    setRecord(res.data.lectures?.rows || []);
                    setTotal(res.data.lectures?.count || 0);
                } else {
                    setRecord([]);
                    setTotal(0);
                    toast.error(res.message);
                }
            } catch (err) {
                hideLoader();
                toast.error(err?.response?.data?.message || err.message);
            }
        }
    };



    // --------------- getting all required masters data ----------------//
    useLayoutEffect(() => {
        const getSubjectsData = async () => {
            try {
                const res = await getMasterSubjects();
                if (res.code === 200) {
                    setAllSubjects(res.data.subjectMaster.rows || []);
                } else {
                    toast.error(res.message);
                }
            } catch (err) {
                toast.error(err?.response?.data?.message || err.message);
            }
        };

        getSubjectsData();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!selectedSubject?.value) return;

        const getSubSubjects = async () => {
            try {
                const res = await getMasterSubSubjects({
                    subject_id: selectedSubject.value,
                });

                if (res.code === 200) {
                    setAllSubSubjects(res.data.subSubjectMaster.rows || []);
                }
            } catch (err) {
                toast.error(err.message);
            }
        };

        getSubSubjects();
    }, [selectedSubject]);


    const subjectOptions = allSubjects.map((s) => ({
        value: s.id,
        label: s.name,
    }));

    const subSubjectOptions = allSubSubjects.map((s) => ({
        value: s.id,
        label: s.name,
    }));


    const getOneMonthLaterDate = () => {
        const date = new Date();
        date.setMonth(date.getMonth() + 1);

        return date.toISOString().split("T")[0]; // yyyy-mm-dd
    };

    const checkUncheckAll = () => {
        if (selectedLectures.length === record.length) {
            setSelectedLectures([]);
        } else {
            const all = record.map((item) => ({
                lectureid: item.LectureID,
                studentid: userData.UserID,
                lecturetitle: item.LectureTitle,
                expireDate: getOneMonthLaterDate(), // ✅ AUTO
                platforms: []
            }));
            setSelectedLectures(all);
        }
    };




    const checkHandler = (lectureId, lectureTitle) => {
        const exists = selectedLectures.find(
            (l) => l.lectureid === lectureId
        );

        if (exists) {
            // ❌ Uncheck
            setSelectedLectures(
                selectedLectures.filter((l) => l.lectureid !== lectureId)
            );
        } else {
            // ✅ Check → add with auto +1 month expiry
            setSelectedLectures([
                ...selectedLectures,
                {
                    lectureid: lectureId,
                    lecturetitle: lectureTitle,   // ✅ FIXED
                    studentid: userData.UserID,
                    expireDate: getOneMonthLaterDate(),
                    platforms: []
                },
            ]);
        }
    };






    const handleDateChange = (lectureId, value) => {
        setSelectedLectures((prev) =>
            prev.map((l) =>
                l.lectureid === lectureId
                    ? { ...l, expireDate: value }
                    : l
            )
        );
    };

    const assignLectureHandler = async () => {
        if (selectedLectures.length === 0) {
            toast.error("Please select at least one lecture");
            return;
        }

        const invalidDate = selectedLectures.some(l => !l.expireDate);
        if (invalidDate) {
            toast.error("Please select expiry date for all lectures");
            return;
        }
        const invalidPlatform = selectedLectures.some(
            l => !l.platforms || l.platforms.length === 0
        );

        if (invalidPlatform) {
            toast.error("Please select at least one platform for each lecture");
            return;
        }

        try {
            setSubmitLoading2(true);
            showLoader();

            const lectureaccesslist = selectedLectures.map((l) => ({
                lectureid: l.lectureid,
                studentid: l.studentid,
                expiredate: l.expireDate,
                lecturetitle: l.lecturetitle,
                courseid: selectedCourse?.value,
                platform: l.platforms.join(",")
            }));

            const res = await addPersonalizedLectureAccessByCourse({
                lectureaccesslist, // 👈 wrapped inside object
            });

            hideLoader();
            setSubmitLoading2(false);

            if (res.code === 200) {
                toast.success("Lectures assigned successfully");
                setSelectedLectures([]);
                searchHandler(new Event("submit"));
            } else {
                toast.error(res.message);
                setSelectedLectures([]);
            }
        } catch (err) {
            hideLoader();
            setSubmitLoading2(false);
            setSelectedCourse(null)
            toast.error(err?.response?.data?.message || err.message);
        }
    };


    const onChangeHandler = (option) => {
        setSelectedCourse(option); // { label, value }
    };

    React.useLayoutEffect(() => {
        const getAllActiveCourses = async () => {
            try {
                showLoader();
                const res = await getactivecourseskyc();
                hideLoader();

                if (res.code === 200) {
                    setAllCourses(
                        res.data.courses?.map((data) => ({
                            label: data.CourseTitle,
                            value: data.CourseID, // ✅ CourseID stored here
                        })) || []
                    );

                } else {
                    toast.error(res.message);
                }
            } catch (err) {
                hideLoader();
                toast.error(err?.response?.data?.message || err.message);
            }
        };
        getAllActiveCourses();
    }, []);

    const getDefaultExpireDate = () => {
        const date = new Date();
        date.setMonth(date.getMonth() + 1);

        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        const yyyy = date.getFullYear();

        return `${mm}/${dd}/${yyyy}`;
    };

    const handlePlatformChange = (lectureId, platform) => {
        setSelectedLectures(prev =>
            prev.map(l => {
                if (l.lectureid !== lectureId) return l;

                const exists = l.platforms.includes(platform);

                return {
                    ...l,
                    platforms: exists
                        ? l.platforms.filter(p => p !== platform)
                        : [...l.platforms, platform],
                };
            })
        );
    };

    return (
        <React.Fragment>
            <title>Shubhra Viraj | Lecture Access</title>
            <div className="">
                <div className="WrapperBox">
                    <div className="Small-Wrapper">
                        <div className="search_wrap">
                            <div className="SearchBox"></div>
                            <h4 className="Title">Lecture Access by course</h4>
                        </div>
                        <div className=" mt-3">
                            <form onSubmit={searchHandler}>
                                <div className="row align-items-center g-3">
                                    <div className="col-md-4">
                                        <Input
                                            className="form-control"
                                            placeholder="Enter User Email Address or Phone"
                                            value={userEmail}
                                            onChange={({ target }) => setUserEmail(target.value)}
                                        />
                                    </div>

                                    <div className="col-md-5">
                                        <ReactSelect
                                            className="w-100 react-select"
                                            placeholder="Select Course"
                                            options={allCourses}
                                            value={selectedCourse}
                                            onChange={onChangeHandler}
                                            isSearchable
                                        />

                                    </div>

                                    <div className="col-md-1">
                                        <Button type="submit" {...submitButtonElement} className="w-100">
                                            Search
                                        </Button>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>

                    {Object.keys(userData).length > 0 && (
                        <div className="Small-Wrapper" style={{ marginTop: "10px" }}>
                            <h5 className="mb-3">Student Details</h5>
                            {Object.keys(userData).length > 0 && (
                                <div className="TableList overflow-auto table-responsive p-0">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Student Name</th>
                                                <th>Email ID</th>
                                                <th>Mobile</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {Object.keys(userData).length > 0 ? (
                                                <tr key={userData.UserID}>
                                                    <td>1</td>
                                                    <td>
                                                        {dataIsAvailable(userData.firstName)}{" "}
                                                        {dataIsAvailable(userData.lastName)}
                                                    </td>
                                                    <td>{dataIsAvailable(userData.EmailID)}</td>
                                                    <td>{dataIsAvailable(userData.Mobile)}</td>
                                                </tr>
                                            ) : (
                                                <NotFound cols={4} />
                                            )}
                                        </tbody>
                                    </table>

                                </div>

                            )}

                        </div>
                    )}

                    {Object.keys(userData).length > 0 && (
                        <div className="Small-Wrapper" style={{ marginTop: "10px" }}>
                            <div
                                className="search_wrap"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    flexWrap: "wrap",
                                    marginBottom: "15px",
                                }}
                            >


                                <Button
                                    className="mx-2"
                                    onClick={assignLectureHandler}
                                    {...submitButtonElement2}
                                    disabled={
                                        selectedLectures.length === 0 ||
                                        selectedLectures.some(l => !l.expireDate)
                                    }
                                >
                                    Assign Lecture
                                </Button>
                                <h5 className="mb-3">Lecture List</h5>
                            </div>
                            {/* Search & Filters Row */}
                            <div
                                className="search_wrap col-md-9"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    flexWrap: "wrap",
                                    marginBottom: "15px",
                                }}
                            >
                                {/* 1️⃣ Lecture Search Input */}
                                <Button className="refresh_btnn mx-1" onClick={resetFilter}>
                                    <i className="fa fa-refresh"></i>
                                </Button>

                                <Button
                                    className="mx-1"
                                    onClick={searchHandler}
                                    {...submitButtonElement}
                                >
                                    Search
                                </Button>

                                {/* 5️⃣ Reset Button */}


                                {/* <div style={{ minWidth: "200px", flex: "1 1 200px" }}>
                                    <ReactSelect
                                        placeholder="Select Sub Subject"
                                        options={subSubjectOptions}
                                        value={selectedSubSubject}
                                        onChange={(option) => setSelectedSubSubject(option)}
                                        isClearable
                                        isDisabled={!selectedSubject}
                                    />
                                </div>

                                <div style={{ minWidth: "200px", flex: "1 1 200px" }}>
                                    <ReactSelect
                                        placeholder="Select Subject"
                                        options={subjectOptions}
                                        value={selectedSubject}
                                        onChange={(option) => {
                                            setSelectedSubject(option);
                                            setSelectedSubSubject(null); // reset sub-subject
                                        }}
                                        isClearable
                                    />
                                </div> */}



                                <div style={{ minWidth: "200px", flex: "1 1 200px" }}>
                                    <Input
                                        className="form-control"
                                        placeholder="Search Here"
                                        value={lecturesearch}
                                        onChange={({ target }) => setlecturesearch(target.value)}
                                        type="text"
                                    />
                                </div>

                                {/* 4️⃣ Search Button */}

                            </div>

                            {loader}



                            {/* Lecture Table */}
                            <div className="TableList overflow-auto table-responsive p-0">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "40px" }}>
                                                {record.length > 0 && (
                                                    <Checkbox
                                                        size="small"
                                                        sx={{
                                                            padding: "0",
                                                            "& .MuiSvgIcon-root": {
                                                                color: "#e14177", // Apply color to the checkmark
                                                            },
                                                            background: "#fff",
                                                            borderRadius: "0",
                                                        }}
                                                        onChange={checkUncheckAll}
                                                        checked={
                                                            record.length > 0 &&
                                                            selectedLectures.length === record.length
                                                        }

                                                    />
                                                )}
                                            </th>
                                            <th>S.No</th>
                                            <th>Lecture Title</th>
                                            {/* <th>Subject</th>
                                            <th>Sub Subject</th> */}
                                            <th className="text-center">Website</th>
                                            <th className="text-center">Tablet</th>
                                            <th className="text-center">Mobile</th>
                                            <th>Expiry Date</th>

                                        </tr>
                                    </thead>

                                    <tbody>
                                        {record.length > 0 ? (
                                            record.map(
                                                (
                                                    { LectureID, LectureTitle, subjectName, subSubjectName, Duration },
                                                    i
                                                ) => (
                                                    <tr key={LectureID}>
                                                        <td>
                                                            <Checkbox
                                                                size="small"
                                                                sx={{
                                                                    padding: "0",
                                                                    "& .MuiSvgIcon-root": {
                                                                        color: "#e14177",
                                                                    },
                                                                }}
                                                                checked={selectedLectures.some(l => l.lectureid === LectureID)}
                                                                onChange={() =>
                                                                    checkHandler(LectureID, LectureTitle) // ✅ PASS TITLE HERE
                                                                }
                                                            />

                                                        </td>
                                                        <td>{i + 1 + (activePage - 1) * 10}</td>
                                                        <td>{dataIsAvailable(LectureTitle)}</td>
                                                        {/* <td>{dataIsAvailable(subjectName)}</td>
                                                        <td>{dataIsAvailable(subSubjectName)}</td> */}
                                                        <td className="text-center">
                                                            <Checkbox
                                                                disabled={!selectedLectures.some(l => l.lectureid === LectureID)}
                                                                checked={
                                                                    selectedLectures
                                                                        .find(l => l.lectureid === LectureID)
                                                                        ?.platforms.includes("Website")
                                                                }
                                                                onChange={() => handlePlatformChange(LectureID, "Website")}
                                                            />
                                                        </td>

                                                        {/* 📱 TABLET */}
                                                        <td className="text-center">
                                                            <Checkbox
                                                                disabled={!selectedLectures.some(l => l.lectureid === LectureID)}
                                                                checked={
                                                                    selectedLectures
                                                                        .find(l => l.lectureid === LectureID)
                                                                        ?.platforms.includes("Tablet")
                                                                }
                                                                onChange={() => handlePlatformChange(LectureID, "Tablet")}
                                                            />
                                                        </td>

                                                        {/* 📱 MOBILE */}
                                                        <td className="text-center">
                                                            <Checkbox
                                                                disabled={!selectedLectures.some(l => l.lectureid === LectureID)}
                                                                checked={
                                                                    selectedLectures
                                                                        .find(l => l.lectureid === LectureID)
                                                                        ?.platforms.includes("Mobile")
                                                                }
                                                                onChange={() => handlePlatformChange(LectureID, "Mobile")}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Input
                                                                type="date"
                                                                className="form-control"
                                                                disabled={!selectedLectures.some(l => l.lectureid === LectureID)}
                                                                value={
                                                                    selectedLectures.find(l => l.lectureid === LectureID)?.expireDate || ""
                                                                }
                                                                onChange={(e) =>
                                                                    handleDateChange(LectureID, e.target.value)
                                                                }
                                                                min={new Date().toISOString().split("T")[0]}
                                                                style={{
                                                                    padding: "5px 7px",
                                                                    fontSize: "14px"
                                                                }}
                                                            />

                                                        </td>

                                                    </tr>
                                                )
                                            )
                                        ) : (
                                            <NotFound cols={5} />
                                        )}
                                    </tbody>
                                </table>
                            </div>





                            {/* Pagination */}
                            {total > 10 && (
                                <div className="Pagination mt-3">
                                    <Pagination
                                        activePage={activePage}
                                        itemsCountPerPage={10}
                                        totalItemsCount={total}
                                        pageRangeDisplayed={5}
                                        onChange={handlePageChange}
                                    />
                                </div>
                            )}
                        </div>
                    )}


                </div>
            </div>


            {/* revoke course access */}
            <ModalBox
                status={revokeModal}
                onClose={() => {
                    setRevokeModal(false);
                    setComment("");
                    setCommentError("");
                }}
                title={"Revoke Course"}
                description={"Are you sure want to revoke course access ?"}
                customizedFooter={
                    <Button
                        //onClick={() => assignCourseHandler("remove")}
                        {...submitButtonElement2}
                    >
                        Yes
                    </Button>
                }
            >
                <div className="form-group row mt-1">
                    <div className="col-sm-12 col-form-label ">
                        <TextArea
                            type="text"
                            name="comment"
                            value={comment}
                            onChange={({ target }) => setComment(target.value)}
                            placeholder="Enter Comment"
                            className={`form-control `}
                            label={"Comment"}
                            error={commentError}
                            required
                            maxLength={200}
                            rows={7}
                            disabled={submitButtonElement2.disabled}
                        />
                    </div>
                </div>
            </ModalBox>

        </React.Fragment>
    );
};

export default PersonalizedLectureAccessByCourse;
